export const StandardScreenWidthTypeSelect = [
  {
    label: "%",
    value: "%",

  },
  {
    label: "px",
    value: "px",

  },
]

export const StandardScreenHeightModeSelect = [
  {
    label: "Auto",
    value: "auto"
  },
  {
    label: "Fixed",
    value: "fixed"
  }
]

export const PopupScreenSelect = [
  {
    label: "Small",
    value: "small",

  },
  {
    label: "Medium",
    value: "medium",

  },
  {
    label: "Large",
    value: "large",

  }
]

export const SliderScreenSelect = [
  {
    label: "Right",
    value: "right",

  },
  {
    label: "Left",
    value: "left",

  },
]

export const CodePopupSelect = [
  {
    label: "HTML",
    value: "HTML",

  },
  {
    label: "React",
    value: "React",

  },
    {
    label: "Angular",
    value: "Angular",

  },
  {
    label: "WordPress",
    value: "WordPress",
  },
]

export const cdnUrl = "https://cdn0.routee.net/sdk/dist/demo/conversational-forms-index.js"
